import React from 'react';
import c from 'classnames';

import './style.scss';

const Message = ({ children, className, type, ...props }) => {
  const classNames = c('Message', className, `Message--${type}`);

  return (
    <div className={classNames} {...props}>
      {children}
    </div>
  );
};

export default Message;
